import { Box, Grid, Typography, useTheme } from "@mui/material";
import { Flex } from "~/components/Flex";
import {
  getRiskFactorColors,
  getRiskFactorIcon,
} from "~/pages/space/security/components/RiskFactors/utils";
import { RiskFactorStats } from "~/operations";
import { useColorMode } from "~/providers/color-mode";

export type RiskFactorsContentProps = {
  riskFactors?:
    | (
        | (RiskFactorStats & {
            description: { active: string; inactive: string };
          })
        | null
      )[]
    | null
    | undefined;
  twoColumn?: boolean;
};

const RiskFactorsContent = ({
  riskFactors,
  twoColumn,
}: RiskFactorsContentProps) => {
  const theme = useTheme();
  const { mode } = useColorMode();

  return (
    <>
      <Box sx={{ pt: 3 }}>
        <Grid container spacing={3}>
          {riskFactors?.map((riskFactor) => {
            const { textColor, fillColor } = getRiskFactorColors({
              theme,
              light: mode === "light",
              isPositive: Boolean(riskFactor?.isPositive),
            });

            return (
              <Grid
                key={riskFactor?.mrn}
                size={{
                  xs: 12,
                  sm: 6,
                  lg: twoColumn ? 6 : 4,
                }}
              >
                <Flex flexDirection="column" gap={1}>
                  <Flex
                    justifyContent="space-between"
                    alignItems="flex-start"
                    gap={1}
                    mb={1}
                    sx={{
                      ".metric-value": {
                        fontWeight: 600,
                        fontSize: 14,
                        textTransform: "uppercase",
                        color: textColor,
                        backgroundColor: fillColor,
                        borderRadius: 1,
                        px: 1,
                        py: 0.5,
                        my: -0.25,
                        maxWidth: 104,
                        flexBasis: "40%",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                    }}
                  >
                    <Flex gap={1}>
                      {getRiskFactorIcon({
                        indicator: riskFactor?.indicator,
                      })}
                      <Typography
                        fontWeight={500}
                        component="span"
                        sx={{ alignSelf: "center" }}
                      >
                        {riskFactor?.title}
                      </Typography>
                    </Flex>
                  </Flex>
                  {riskFactor?.description && (
                    <Typography variant="caption" color="text.secondary">
                      {riskFactor.description.active}
                    </Typography>
                  )}
                </Flex>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};

export default RiskFactorsContent;
